import { container } from './container';
import { SERVICE_KEYS } from './SERVICE_KEYS';
import { SessionRepositoryApi } from '../../data/sources/api/SessionRepositoryApi';
import { GetMySessions } from '../../domain/usecases/GetMySessions';
import { OpenSession } from '../../domain/usecases/OpenSession';
import { sessionApi } from '../../data/sources/api/sessionApi';

// Конфигурация DI контейнера
export function configureServices(): void {
  // Регистрируем API сервисы
  container.register(SERVICE_KEYS.SESSION_API, sessionApi);

  // Регистрируем репозитории (используем API реализацию)
  container.register(SERVICE_KEYS.SESSION_REPOSITORY, new SessionRepositoryApi());

  // Регистрируем use cases
  container.register(SERVICE_KEYS.GET_MY_SESSIONS, 
    new GetMySessions(container.resolve(SERVICE_KEYS.SESSION_REPOSITORY))
  );

  container.register(SERVICE_KEYS.OPEN_SESSION,
    new OpenSession(container.resolve(SERVICE_KEYS.SESSION_REPOSITORY))
  );
}



// Функция для проверки готовности контейнера
export function isContainerConfigured(): boolean {
  return container.has(SERVICE_KEYS.SESSION_REPOSITORY) &&
         container.has(SERVICE_KEYS.GET_MY_SESSIONS) &&
         container.has(SERVICE_KEYS.OPEN_SESSION);
}
